import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { ChevronDown } from 'react-feather'
import Image from 'components/CompatImage'
import type { SwapToken } from 'utils/swap/types'

/**
 * The pill inside an amount field that opens the token list. Restored from the
 * exchange's own Swap tab, so it reads the same as the bridge's contract
 * picker sitting one tab away.
 */
const Wrapper = styled(Flex)`
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  /* A thumb needs 44px; the pill is smaller, so the tap area is padded out. */
  min-height: 44px;
  align-items: center;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.gray10};
  white-space: nowrap;
`

const ImageWrapper = styled(Flex)`
  position: relative;
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.gray9};
`

interface TokenSelectorProps {
  token: SwapToken | null
  onSelectorClick?: () => void
}

const TokenSelector: React.FC<TokenSelectorProps> = ({ token, onSelectorClick }) => {
  const { colors } = useTheme()

  return (
    <Wrapper onClick={onSelectorClick}>
      {token?.logoURI ? (
        <ImageWrapper>
          <Image src={token.logoURI} layout="fill" />
        </ImageWrapper>
      ) : null}
      <Text clickable variant={TextVariant.BODY_SMALL_BOLD}>
        {token?.symbol ?? '—'}
      </Text>
      <ChevronDown color={colors.white} size={18} />
    </Wrapper>
  )
}

export default TokenSelector
